// source: template-project@7007a338a apps/backoffice/src/components/ui/shadcn/input.tsx
// Vendored from shadcn/ui — MODIFIED:
//   - `search` variant (not in the registry): the toolbar search recipe from cursor
//     rule 23 ("Search inputs"), on ds tokens.
//   - base ring/border/text classes moved off the `neutral-*` palette onto
//     border-border / text-foreground / text-muted-foreground / border-border-hover.
//   - `control` variant: the 32px / rounded-md geometry dialogs and toolbars are laid
//     out on (DESIGN_SYSTEM.md §7, Law 4.2), on raised with border-default (Laws 2.1, 2.3). The file-button
//     type moved off the base onto the variants that keep `text-sm`: on `control` it would stack on its type style.
// Do NOT regenerate with `npx shadcn add input --overwrite` without re-applying these edits.
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const inputVariants = cva(
  // rounded-lg → var(--radius) per tailwind.config (shadcn control radius)
  "flex w-full rounded-lg border border-input bg-card ring-offset-background file:border-0 file:bg-transparent file:text-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "file:text-sm file:font-medium h-10 px-3 py-2 text-base placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 md:text-sm",
        // MODIFIED: neutral-200/900/500/300 -> border-border/text-foreground/text-muted-foreground/border-border-hover (ds sweep, Phase 4 Wave B; audit §V5).
        control: "h-8 rounded-md border-ds-border-default bg-ds-raised px-3 py-1 text-body-sm text-foreground placeholder:text-ds-text-2 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        search: "file:text-sm file:font-medium h-11 rounded-xl border-border pl-10 pr-4 text-sm text-foreground placeholder:text-muted-foreground focus-visible:border-ds-border-default dark:focus-visible:border-input focus-visible:ring-2 focus-visible:ring-foreground/10 focus-visible:ring-offset-0",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface InputProps
  extends React.ComponentProps<"input">,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input, inputVariants }
